<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-07-11 17:29:18
 * @LastEditors: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @LastEditTime: 2025-04-01 11:01:13
 * @FilePath: /qd-yunjing-web/src/components/base-area-select/index.vue
 * @Description: 这是默认设置,请设置`customMade`,
-->
<template>
  <section class="area-select-container">
    <div
      ref="spaceContainerRef"
      class="space-container"
    >
      <!-- <el-button
        key="plain"
        type=""
        text
      >
        <span class="value">{{ spaceValue }} </span>  <el-icon class="el-icon--right"><arrow-down /></el-icon>
      </el-button> -->
      <el-cascader
        ref="refCascader"
        v-model:visible="visible"
        v-model="space"
        :props="spaceProps"
        class="space-cascader"
        :options="spaceOptions"
        collapse-tags
        clearable
        @change="handleValChange"
      />
    </div>
  </section>
</template>
<script setup lang="ts">
  import {
    ref, computed,
  } from 'vue';
  import { useOrgStore } from '@/store/org';
  import { CascaderProps } from 'element-plus';

  const props = defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
    isMultiple: { // 是否多选
      type: Boolean,
      default: false,
    },
    level: { // 子级展示层数
      type: Number,
      default: 0,
    },
  });

  const visible = ref(false);
  const emit = defineEmits(['area-change']);
  const orgStore = useOrgStore();
  const refCascader = ref();
  const spaceContainerRef = ref();

  const space = computed(() => orgStore.spaceValue);

  const spaceOptions = computed(() => {
    if (props.level === 2) {
      // 一般都是展示到楼层，
      const treeData = JSON.parse(JSON.stringify(orgStore.spaceOptions));
      treeData.forEach((rootNode:any) => {
        rootNode.children?.forEach((child:any) => delete child.children);
      });
      console.log('treeData', treeData, orgStore.spaceOptions);
      if (treeData.length > 0) {
        return [{
          id: 0,
          name: '全部',
          orgId: '0',
          code: '0',
          children: treeData,
        }];
      }
      return [{
        id: 0,
        name: '全部',
        orgId: '0',
        code: '0',
      }];
    }
    return {
      id: 0,
      name: '全部',
      orgId: '0',
      code: '0',
      children: orgStore.spaceOptions,
    };
  });

  const basespaceOptions = computed(() => orgStore.spaceOptions) as any;
  // const spaceOptions = computed(() => orgStore.spaceOptions);

  const spaceProps:CascaderProps = {
    checkStrictly: true,
    label: 'name',
    value: 'code',
    expandTrigger: 'click',
    multiple: props.isMultiple,
  };

  const getLastCode = (nodes: any[]): any[] => nodes.reduce((result: any[], node: any) => {
    // 总是添加当前节点的code
    result.push(node.code || node.value);

    // 如果有子节点，递归处理并合并结果
    if (node.children && node.children.length > 0) {
      result = result.concat(getLastCode(node.children));
    }

    return result;
  }, []);

  /*
   * const getLastCode = (node:any):any => {
   *   let m:any = [];
   *   for (let i = 0; i < node.length; i++) {
   *     if (!(node[i]?.children) || node[i]?.children.length === 0) {
   *       m.push(node[i].code);
   *     } else {
   *       m.push(node[i].code);
   *       m = m.concat(getLastCode(node[i].children));
   *     }
   *   }
   *   return m;
   * };
   */

  const handleValChange = (val: any) => {
    console.log('val', val);
    orgStore.setSpaceValue(val);

    const node = refCascader.value.getCheckedNodes();
    console.log('node', node);
    let emitData = [];
    if (node[0].value === '0') {
      emitData = getLastCode(basespaceOptions.value);
    } else if (props.level === 2) {
      let temp = [];
      for (let i = 0; i < basespaceOptions.value.length; i++) {
        if (node[0].value === basespaceOptions.value[i].code) {
          temp = basespaceOptions.value[i];
          break;
        }
        for (let j = 0; j < basespaceOptions.value[i].children?.length; j++) {
          if (node[0].value === basespaceOptions.value[i].children[j].code) {
            temp = basespaceOptions.value[i].children[j];
            break;
          }
        }
      }
      console.log('temp', [temp]);
      emitData = getLastCode([temp]);
    } else {
      emitData = getLastCode(node);
    }
    emit('area-change', emitData);
    orgStore.setMultiSpace(emitData);
    if (node && node.length) {
      const value = node[0].pathNodes;
      orgStore.setCurrentSpace(value[value.length - 1].data);
    }

    if (!props.isMultiple) {
      visible.value = false;
    }
  };
</script>
<style scoped lang="scss">
.area-select-container{
  flex: 1;
  width: 100%;
  margin-left: 10px;

  .space-container {
    width: 300px;
    overflow: hidden;
    line-height: 28px;
    background-color: transparent;
    border-radius: 5px;
  }
}

:deep(.ma-tag--light){
  background-color: #fff;
}
</style>
<style>
.area-cascader1{
  width: 160px !important;
  overflow: hidden;
}

.area-cascader2{
  width: 340px !important;
  overflow: hidden;
}

.area-cascader3{
  width: 500px !important;
  overflow: hidden;
}
</style>
